import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scroller", "left", "right"]

  connect() {
    this.scrollerTarget.scrollLeft = parseInt(this.scrollerTarget.dataset.scrollPosition, 10) || 0
    this.observer = new ResizeObserver(() => this.update())
    this.observer.observe(this.scrollerTarget)
    this.update()
  }

  disconnect() {
    this.observer?.disconnect()
    cancelAnimationFrame(this.frame)
    this.frame = null
  }

  update() {
    if (this.frame) return
    this.frame = requestAnimationFrame(() => {
      this.frame = null
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollerTarget
      const position = Math.round(scrollLeft)
      this.leftTarget.style.display = position <= 0 ? "none" : "flex"
      this.rightTarget.style.display = scrollWidth <= clientWidth || Math.abs(scrollWidth - clientWidth - position) <= 1 ? "none" : "flex"
    })
  }

  previous() {
    this.scrollerTarget.scrollBy({ left: -this.scrollerTarget.clientWidth, behavior: "smooth" })
  }

  next() {
    this.scrollerTarget.scrollBy({ left: this.scrollerTarget.clientWidth, behavior: "smooth" })
  }
}
